// Running clocks for self-drawing strokes (landing spec §3.1, §3.2). Pure.

export const CARRY_UNITS = 1.5

export function clamp01(x: number): number {
    return x < 0 ? 0 : x > 1 ? 1 : x
}

export function strokeClock(q: number, n: number): number[] {
    return Array.from({ length: n }, (_, i) => clamp01(q - i))
}

// Composed glyph: new strokes cost one unit each in order; the carried
// block costs CARRY_UNITS once, at the index where it first appears, and
// every carried stroke shows the same amount (it fades guide → ink as one).
export function carryClock(
    q: number,
    n: number,
    carried: ReadonlySet<number>
): { drawn: number[]; carried: number } {
    const drawn = new Array<number>(n).fill(0)
    let u = 0
    let ink = 0
    let seen = false
    for (let j = 0; j < n; j++) {
        if (carried.has(j)) {
            if (!seen) {
                seen = true
                ink = clamp01((q - u) / CARRY_UNITS)
                u += CARRY_UNITS
            }
            drawn[j] = ink
        } else {
            drawn[j] = clamp01(q - u)
            u += 1
        }
    }
    return { drawn, carried: ink }
}

// Hover/band writing: the glyph writes one stroke at a time, each over
// `strokeS`, the next starting only when the last has landed — a pen, not
// a wave of ink. The glyph's duration is n · strokeS.
export const WRITE_STROKE_S = 0.22

export function writeDrawn(
    elapsedS: number,
    n: number,
    strokeS = WRITE_STROKE_S
): number[] {
    return Array.from({ length: n }, (_, i) =>
        clamp01((elapsedS - i * strokeS) / strokeS)
    )
}
